import { ICellRef, IMobCellEvent } from "@/store/apis/socketRegistry"

export interface ICellRead {
  events(): IMobCellEvent[]
  close(): void
}

export interface ICellReadRegistry {
  begin(cellKey: string): ICellRead
  record(cellKey: string, event: IMobCellEvent): void
}

export const cellKeyOf = ({ mapId, x, y }: ICellRef): string =>
  `${mapId}:${x}:${y}`

/** One handle per read, not per cell: an aborted read's `queryFn` runs on to its answer while a new read of the entry starts. */
export const createCellReadRegistry = (): ICellReadRegistry => {
  const open = new Map<string, Set<IMobCellEvent[]>>()
  return {
    begin(cellKey) {
      const events: IMobCellEvent[] = []
      const reads = open.get(cellKey) ?? new Set<IMobCellEvent[]>()
      reads.add(events)
      open.set(cellKey, reads)
      return {
        events: () => [...events],
        close: () => {
          reads.delete(events)
          if (reads.size === 0 && open.get(cellKey) === reads) {
            open.delete(cellKey)
          }
        }
      }
    },
    record(cellKey, event) {
      open.get(cellKey)?.forEach((events) => events.push(event))
    }
  }
}

export const cellReads = createCellReadRegistry()
